import React from 'react';
import { Input, Button } from 'components';
import { FaSearch } from 'react-icons/fa';
import { SearchForm } from './styles';
import { navigate, useLocation } from '@reach/router';
import queryString from 'query-string';

export function Search() {
    const [searchTerm, setSearchTerm] = React.useState('');

    const { search } = useLocation();
    const c = queryString.parse(search)?.c || '';

    const handleSubmit = (e) => {
        e.preventDefault()

        if (c) {
            navigate(`/all-products/?c=${encodeURIComponent(c)}&s=${encodeURIComponent(searchTerm)}`)
        } else {
            navigate(`/all-products/?s=${encodeURIComponent(searchTerm)}`)
        }
    }

    return (
        <SearchForm onSubmit={handleSubmit}>
            <Input
                value={searchTerm}
                onChange={(e) => (setSearchTerm(e.currentTarget.value))}
                placeholder="Search"
            />
            <Button>
                <FaSearch />
            </Button>
        </SearchForm>
    );
}